import { ReactElement } from 'react';
import { useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import { BreOrderContext } from '~/tenants/bre/model/BreOrderContext';
import { BreCinematicRate } from '~/tenants/bre/performable/cinematic/BreCinematicData';
import { VOICE_OPTS } from '~/tenants/bre/performable/common';
import { PersonaType } from '~/tenants/common/TenantPersona';
import { TenantPackageAddOnCards, TenantPackageAddOnCheckboxName } from '~/tenants/common/package';
import ZodFieldHidden from '~/components/zod/ZodFieldHidden';

interface BreCinematicAddOnsProps {
  context: BreOrderContext;
  persona: PersonaType;
}

export default function BreCinematicAddOns({ context, persona }: BreCinematicAddOnsProps): ReactElement {
  const { AERIAL_PHOTOS, INTRO, KWASI, NARRATION, TWILIGHT, AERIAL_UPGRADE } = BreCinematicRate[context.metadata.type];

  return (
    <>
      <TenantPackageAddOnCheckboxName
        name="aerial_upgrade"
        title="Aerial Upgrade"
        description="Adds aerial to the Cinematic Video and 5 aerial photos (Must meet FAA area rules for the address)"
        image="tenant/bre/cinematic/aerial_upgrade.jpg"
        persona={persona}
        cost={AERIAL_UPGRADE}
      />
      <TenantPackageAddOnCheckboxName
        name="intro"
        title="Agent Intro"
        description="Add agent on camera intro."
        image="tenant/bre/cinematic/intro.jpg"
        persona={persona}
        cost={INTRO}
      />
      <TenantPackageAddOnCheckboxName
        name="narration"
        title="Agent Voice-Over"
        description="Add agent narration."
        image="tenant/bre/cinematic/narration.jpg"
        persona={persona}
        cost={NARRATION}
      />
      <TenantPackageAddOnCards
        name="kwasi"
        title="Professional Voice-Over"
        description="Enhance your video with a professional voice-over and script."
        image="tenant/bre/cinematic/kwasi.png"
        persona={persona}
        options={VOICE_OPTS}
        cost={KWASI}
        cols={2}
        required
      />
      <TenantPackageAddOnCheckboxName
        name="twilight"
        title="Twilight Transitions"
        description="Day-to-Dusk Twilight Transitions"
        image="tenant/bre/cinematic/twilight.jpg"
        persona={persona}
        cost={TWILIGHT}
      />
      <TenantPackageAddOnCheckboxName
        name="aerial_photos"
        title="5 Aerial Photos"
        description="Add 5 additional aerial photos."
        image="tenant/bre/cinematic/aerial_photos.jpg"
        persona={persona}
        cost={AERIAL_PHOTOS}
      />
    </>
  );
}
